<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" :key="index" v-for="(routeObject, index) in routeRecords">
      <span class="active" v-if="isLast(index)">{{ getName(routeObject) }}</span>
      <router-link :to="routeObject" v-else>{{ getName(routeObject) }}</router-link>
    </li>
  </ol>
</template>

<style scoped>
.breadcrumb {
  font-size: 12px;
  color: #ccc;
}
</style>

<script>
export default {
  props: {},
  computed: {
    routeRecords: function () {
      return this.list.filter((route) => route.name || route.meta.label)
    },

    list() {
      return this.$store.getters.getBreadcrumbs
    }
  },
  methods: {
    getName (item) {
      const name = item.meta && item.meta.label ? item.meta.label : item.name || null

      return this.$t(name)
    },
    isLast (index) {
      return index === this.list.length - 1
    }
  }
}
</script>
